import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons/faArrowDownToBracket'
import Icon from '@space-core/components/icon'

import type { ApplicationPwaConfig } from '@space-shell/common/services/membership'
import { useMembershipStore } from '@space-shell/core/store'

import { useTranslation } from 'react-i18next'

import { PwaIosModal } from './components/pwaIosModal'
import { IOS_MOBILE_ACCEPTED_BROWSERS, OS_ACCEPTED_TO_CUSTOM_MODAL } from './constants'
import useBannerPwaInstall from './hooks/useBannerPwaInstall'
import * as S from './style'

import { systemDetails } from './utils'

const PwaBar = () => {
  const { membershipData } = useMembershipStore()
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const { browser, device, os } = systemDetails()
  const isBrowserAccepted = IOS_MOBILE_ACCEPTED_BROWSERS.includes(browser?.name)
  const isMobile = device?.type === 'mobile'
  const canInstallPwaIOS = 'standalone' in window.navigator
  const isPwaIOSInstalled = window.navigator?.standalone === true

  const isIOS_ModalDecision =
    (OS_ACCEPTED_TO_CUSTOM_MODAL.includes(os?.name) &&
      isMobile &&
      isBrowserAccepted &&
      canInstallPwaIOS &&
      !isPwaIOSInstalled) ||
    false

  const {
    isBannerClosed,
    setIsBannerClosed,
    isModalOpen,
    setIsModalClosed,
    callBrowserDefaultPwaBanner,
    callIOSModalPwaBanner
  } = useBannerPwaInstall({
    shouldUseIOSModal: isIOS_ModalDecision,
    language,
    membershipData
  })

  const pwaConfigs: ApplicationPwaConfig | undefined = membershipData!.settings!.application!.find(
    (item) => !!item.imageUrlLogo && item.switchPwa
  )
  const imageUrlLogo: string = pwaConfigs ? pwaConfigs?.imageUrlLogo : ''

  const handleClickOnBanner = () => {
    if (isIOS_ModalDecision) {
      return callIOSModalPwaBanner()
    }

    callBrowserDefaultPwaBanner()
  }

  return (
    <>
      <S.Wrapper
        className='_d-flex _w-full'
        isBannerClosed={isBannerClosed}
        aria-label={`${isBannerClosed ? 'hidden' : 'visible'}`}>
        <S.WrapperMain className='_text-white'>
          <S.MainClickableArea onClick={handleClickOnBanner}>
            <Icon icon={faArrowDownToBracket} size='sm' className='banner-icon' />
            <div className='_text-1'>{t('pwa.description')}</div>
            {imageUrlLogo && (
              <S.LogoBanner className='' src={imageUrlLogo} alt='pwa banner logo' loading='eager' />
            )}
          </S.MainClickableArea>
        </S.WrapperMain>
        <S.CloseButton className='_text-white' onClick={setIsBannerClosed} aria-label='close'>
          <Icon icon={faXmark} size='lg' />
        </S.CloseButton>
      </S.Wrapper>

      <PwaIosModal isModalOpen={isModalOpen} handleCloseModal={() => setIsModalClosed()} />
    </>
  )
}

export default PwaBar
